module.exports = __webpack_public_path__ + "img/fineness-2.57923c4.png";